








































import Vue from 'vue';
import { BFormInput, BCol, BRow } from 'bootstrap-vue';
import ColorPicker from '@reciprocity/color-picker';
import { cloneDeep } from 'lodash';
import { RiskCardType, RiskAddOrRemoveItemsType } from '../types';

export default Vue.extend({
  name: 'RiskAddOrRemoveItems',
  components: {
    BFormInput,
    BCol,
    BRow,
    ColorPicker,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    labels: {
      type: Array,
      required: true,
      validator: prop => prop.length === 2,
    },
    fieldType: {
      type: String as () => RiskCardType,
      default: RiskCardType.AddOrRemoveItems,
      validator: prop => [RiskCardType.AddOrRemoveItems, RiskCardType.AddOrRemoveItemsWithColor].includes(prop),
    },
    addOrRemoveItemsType: {
      type: String as () => RiskAddOrRemoveItemsType,
      default: RiskAddOrRemoveItemsType.FactorOptions,
    },
  },
  data() {
    return {
      items: cloneDeep(this.value),
    };
  },
  computed: {
    colorIncluded() {
      return this.fieldType === RiskCardType.AddOrRemoveItemsWithColor;
    },
    numberOfCols() {
      return this.colorIncluded ? 8 : 9;
    },
    addButtonText() {
      return this.addOrRemoveItemsType === 'factorOptions' ? 'Add Option' : 'Add Range';
    },
  },
  watch: {
    items: {
      handler() {
        this.$emit('input', this.items);
      },
      deep: true,
    },
  },
  async created() {
    if (!this.value.length) {
      this.addItem();
    }
  },
  methods: {
    addItem() {
      this.items.push({
        id: null,
        name: '',
        value: null,
        ...(this.colorIncluded && { color: '#FFFFFF' }),
      });
    },
    removeItem(index: number) {
      this.items.splice(index, 1);
    },
  },
});
